<template>
  <div class="content">
    <div class="container-fluid">
      <div v-if="messageAlert">
        <Notification :message="messageAlert" @statusAlertMsg="cambiarMsgAlert" />
      </div>
      <div>
        <DxDataGrid id="gridContainer" :data-source="dataSource" key-expr="id" :column-hiding-enabled="true"
          :show-borders="true" @exporting="onExporting">
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true" />
          <DxGrouping :context-menu-enabled="true" expand-mode="rowClick" />
          <DxGroupPanel :visible="true"
            empty-panel-text="Use el menú contextual de las columnas de encabezado para agrupar datos" />
          <DxColumnChooser :enabled="true" mode="select" />
          <DxExport :enabled="true" :formats="['pdf', 'xlsx']" />
          <DxColumn dataField="id" caption="" :showInColumnChooser="false" :allowFiltering="false" :allowSorting="false"
            cellTemplate="cellEditar" :fixed="true" width='10%' />
          <DxColumn dataField="nombre" caption="Nombre" />
          <DxColumn dataField="email" caption="Correo electrónico" />
          <DxColumn dataField="telefono" caption="Teléfono" />
          <DxColumn dataField="contacto" caption="Contacto" />
          <DxColumn dataField="estatus" caption="Estatus" width='10%' />
          <DxColumn dataField="notas" caption="Notas" />
          <DxToolbar>
            <DxItem location="before" name="groupPanel" />
            <DxItem location="after" template="refreshTemplate" />
            <DxItem location="after" name="exportButton" />
            <DxItem location="after" name="columnChooserButton" />
          </DxToolbar>
          <template #refreshTemplate>
            <DxButton icon="plus" @click="agregarPropietario()" />
          </template>
          <DxPager :allowed-page-sizes="[5, 8, 15, 30]" :show-info="true" :show-navigation-buttons="true"
            :show-page-size-selector="true" :visible="true" />
          <template #cellEditar="{ data }">
            <div class="text-center">
              <a href="#" class="text-decoration-none me-2 fas fa-pen fa-sm" @click="abrirModalEditar(data)"
                title="Editar"></a>
              <a href="#" :class="data.data.status == 0 ? 'me-2 fas fa-lock fa-sm' : 'me-2 fas fa-unlock fa-sm'"
                @click="abrirModalStatusFila(data)" :title="data.data.status == 0 ? 'Activar' : 'Desactivar'"
                style="text-decoration:none;"></a>
            </div>
          </template>
          <DxPaging :page-size="8" />
        </DxDataGrid>
      </div>
      <dx-popup :height="'auto'" :showTitle="true" titleTemplate="titleModal" :dragEnabled="false"
        :hideOnOutsideClick="true" :visible="popupVisibleCreate" @hidden="onHidden">
        <template #titleModal>
          <h3>{{ titleModal }}</h3>
        </template>
        <div>
          <form action="">
            <div class="form">
              <div class="dx-fieldset">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <dx-text-box label="Nombre:" v-model="propietario.nombre"></dx-text-box>
                    <small class="error_message" v-for="(e_nombre, index) in errors.nombre"
                      :key="index">{{ e_nombre }}</small>
                  </div>
                  <div class="col-md-6">
                    <dx-text-box label="Contacto:" v-model="propietario.contacto"></dx-text-box>
                    <small class="error_message" v-for="(e_contacto, index) in errors.contacto"
                      :key="index">{{ e_contacto }}</small>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <dx-text-box label="Teléfono:" v-model="propietario.telefono"></dx-text-box>
                    <small class="error_message" v-for="(e_telefono, index) in errors.telefono"
                      :key="index">{{ e_telefono }}</small>
                  </div>
                  <div class="col-md-6">
                    <dx-text-box label="Correo electrónico:" v-model="propietario.email"></dx-text-box>
                    <small class="error_message" v-for="(e_email, index) in errors.email"
                      :key="index">{{ e_email }}</small>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <div v-if="option == 'edit'" class="dx-field">
                      <div class="dx-field-label">Estatus:</div>
                      <div class="dx-field-value">
                        <div v-if="propietario.status == 1" class="dx-field-label">Activo</div>
                        <div v-if="propietario.status == 0" class="dx-field-label">Inactivo</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                </div>
                <div class="row mb-2">
                  <div class="col-md-12">
                    <DxTextArea label="Notas:" :height="90" v-model="propietario.notas" :max-length="maxLength" />
                    <small class="error_message" v-for="(e_notas, index) in errors.notas"
                      :key="index">{{ e_notas }}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-end">
                    <dx-button class="me-2" type="normal" text="Cancelar" @click="cancelarEditar()"></dx-button>
                    <dx-button class="me-2" v-if="option == 'save'" icon="save" type="default" text="Guardar"
                      @click="nuevoPropietario()"></dx-button>
                    <dx-button class="me-2" v-if="option == 'edit' && propietario.status == 1" icon="clear" type="danger"
                      text="Inactivar" @click="abrirModalStatusEditar()"></dx-button>
                    <dx-button class="me-2" v-if="option == 'edit' && propietario.status == 0" icon="fas fa-unlock fa-sm"
                      type="default" text="Activar" @click="abrirModalStatusEditar()"></dx-button>
                    <dx-button class="me-2" v-if="option == 'edit'" icon="fas fa-lock fa-sm" type="default" text="Guardar"
                      @click="actualizarPropietario()"></dx-button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </dx-popup>
      <dx-popup :width="'auto'" :height="'auto'" :showTitle="true" titleTemplate="titleModal" :dragEnabled="false"
        :hideOnOutsideClick="true" :visible="popupVisibleDelete" @hidden="onHiddenDelete">
        <template #titleModal>
          <h3>Eliminar propietario</h3>
        </template>
        <div>
          <div class="row">
            <div class="col-md-12">
              <h3>¿Deseas eliminar al propietario "{{ propietario_nombre }}"?</h3>
              <br>
            </div>
          </div>
          <div class="row">
            <div class="modal-footer">
              <dx-button class="me-2" type="normal" text="Cancelar" @click="cancelarEliminar()"></dx-button>
              <dx-button icon="trash" type="danger" text="Eliminar" @click="eliminar()"></dx-button>
            </div>
          </div>
        </div>
      </dx-popup>
      <dx-popup :width="'auto'" :height="'auto'" :showTitle="true" titleTemplate="titleModal" :dragEnabled="false"
        :hideOnOutsideClick="true" :visible="popupVisibleStatus" @hidden="onHiddenStatus">
        <template #titleModal>
          <h3>{{ titleStatus }} propietario</h3>
        </template>
        <div>
          <div class="row">
            <div class="col-md-12">
              <h3>¿Deseas {{ titleStatus.toLowerCase() }} al propietario "{{ propietario_nombre }}"?</h3>
              <br>
            </div>
          </div>
          <div class="row">
            <div class="modal-footer">
              <dx-button class="me-2" type="normal" text="Cancelar" @click="cancelarStatus()"></dx-button>
              <dx-button type="danger" :text="propietario_status == 1 ? 'Desactivar' : 'Activar'"
                @click="cambiarStatus()"></dx-button>
            </div>
          </div>
        </div>
      </dx-popup>
    </div>
  </div>
</template>
<script>

import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxLookup,
  DxForm,
  DxScrolling,
  DxPager,
  DxExport,
  DxHeaderFilter,
  DxFilterRow,
  DxColumnFixing,
  DxColumnChooser,
  DxSelection,
  DxStateStoring,
  DxGroupPanel,
  DxToolbar,
  DxEditing,
  DxGrouping,
} from 'devextreme-vue/data-grid';
import {
  DxValidator,
  DxRequiredRule,
  DxCustomRule
} from 'devextreme-vue/validator';

import { DxTextArea } from 'devextreme-vue/text-area';
import { DxTextBox } from 'devextreme-vue/text-box';
import { DxItem } from 'devextreme-vue/form';
import { DxPopup } from 'devextreme-vue/popup';
import { DxButton } from 'devextreme-vue/button';
import { DxCheckBox } from 'devextreme-vue';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';

import axios from "axios";
import Notification from "./NotificationComponent";
import 'devextreme/dist/css/dx.light.css';
import "bootstrap/dist/css/bootstrap.min.css";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxItem,
    DxTextArea,
    DxScrolling,
    DxPager,
    DxExport,
    DxHeaderFilter,
    DxFilterRow,
    DxColumnFixing,
    DxColumnChooser,
    DxSelection,
    DxStateStoring,
    DxGroupPanel,
    DxPopup,
    DxButton,
    DxTextBox,
    DxToolbar,
    DxValidator,
    DxRequiredRule,
    DxCustomRule,
    DxCheckBox,
    DxSelectBox,
    DxLoadPanel,
    Notification,
    DxEditing,
    DxGrouping,
  },
  data() {
    return {
      dataSource: [],
      displayModes: [{ text: 'Display Mode \'full\'', value: 'full' }, { text: 'Display Mode \'compact\'', value: 'compact' }],
      displayMode: 'full',
      pageSizes: [5, 10, 'all'],
      showPageSizeSelector: true,
      showInfo: true,
      showNavButtons: true,
      errors: [],
      propietario_id: "",
      propietario_nombre: "",
      propietario_status: 1,
      titleStatus: "Activar",
      titleModal: "",
      option: "save",
      propietario: {
        id: "",
        nombre: "",
        email: "",
        telefono: "",
        contacto: "",
        notas: "",
        status: "",
      },
      popupVisibleCreate: false,
      popupVisibleDelete: false,
      popupVisibleStatus: false,
      titleStatus: "Activar",
      searchModeOption: 'contains',
      searchExprOption: 'name',
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: false,
      isLoadPanelVisible: false,
      messageAlert: 0,
      maxLength: null,
    }
  },
  methods: {
    onExporting(e) {
      if (e.format === 'xlsx') {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
          component: e.component,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: 'Arial', size: 12 };
            excelCell.alignment = { horizontal: 'left' };
          }
        }).then(function () {
          workbook.xlsx.writeBuffer()
            .then(function (buffer) {
              saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'propietarios.xlsx');
            });
        });
        e.cancel = true;
      }
      else if (e.format === 'pdf') {
        const doc = new jsPDF('l', 'mm', [297, 210]);
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: e.component
        }).then(() => {
          doc.save('propietarios.pdf');
        })
      }
    },
    cambiarMsgAlert(value) {
      this.messageAlert = value;
    },
    cleanTextBox() {
      this.propietario.id = "";
      this.propietario.nombre = "";
      this.propietario.email = "";
      this.propietario.telefono = "";
      this.propietario.contacto = "";
      this.propietario.notas = "";
      this.propietario.status = "";
    },
    agregarPropietario() {
      this.cleanTextBox();
      this.showChildModal();
      this.titleModal = "Nuevo propietario"
      this.option = "save";
    },
    showChildModal() {
      this.popupVisibleCreate = true;
    },
    nuevoPropietario() {
      axios.post('propietarios', this.propietario).then(response => {
        if (response && response.data.statusCode == 200) {
          this.messageAlert = response.data.message;
          this.cleanTextBox();
          this.hideChildModal();
          this.getList();
        }
        else {
          console.log(response);
        }
      }).catch((error) => {
        if (error.response.status == 422) {
          this.errors = error.response.data.errors;
        } else {
          console.log(this.errors);
        }
      });
    },

    hideChildModal() {
      this.popupVisibleCreate = false;
    },
    abrirModalEditar(value) {
      this.titleModal = "Editar propietario"
      this.option = "edit";
      this.cleanTextBox();
      this.showChildModal();
      this.propietario_id = value.value;
      this.propietario_nombre = value.data.nombre;
      this.propietario_status = value.data.status;
      this.propietario.id = value.value;
      this.propietario.nombre = value.data.nombre;
      this.propietario.email = value.data.email;
      this.propietario.telefono = value.data.telefono;
      this.propietario.contacto = value.data.contacto;
      this.propietario.status = value.data.status;
      this.propietario.notas = value.data.notas;
    },
    cancelarEditar() {
      this.cleanTextBox();
      this.hideChildModal();
      this.errors = [];
    },
    onHidden(e) {
      this.cancelarEditar();
    },
    abrirModalStatusFila(value) {
      this.popupVisibleStatus = true;
      this.propietario_id = value.value;
      this.propietario_nombre = value.data.nombre;
      this.propietario_status = value.data.status;
      this.titleStatus = value.data.status == 1 ? 'Desactivar' : 'Activar';
    },
    abrirModalStatusEditar() {
      this.popupVisibleCreate = false;
      this.popupVisibleStatus = true;
      this.propietario_status = this.propietario.status;
      this.titleStatus = this.propietario.status == 1 ? 'Desactivar' : 'Activar';
      this.propietario_id = this.propietario.id;
      this.propietario_nombre = this.propietario.nombre;
    },
    cambiarStatus() {
      axios.post('banned-propietario/' + this.propietario_id).then(response => {
        this.messageAlert = response.data.message;
        this.popupVisibleStatus = false;
        this.cleanTextBox();
        this.getList();
      });
    },
    cancelarStatus() {
      this.popupVisibleStatus = false;
      this.propietario_id = "";
      this.propietario_nombre = "";
    },
    abrirModalEliminar(value) {
      this.popupVisibleDelete = true;
      this.propietario_id = value.value;
      this.propietario_nombre = value.data.nombre;
    },
    actualizarPropietario() {
      axios.put('propietarios/' + this.propietario_id, this.propietario).then(response => {
        if (response && response.data.statusCode == 200) {
          this.messageAlert = response.data.message;
          this.cleanTextBox();
          this.hideChildModal();
          this.getList();
        }
        else {
          console.log(response);
        }
      }).catch((error) => {
        if (error.response.status == 422) {
          this.errors = error.response.data.errors;
        } else {
          console.log(this.errors);
        }
      });
    },
    cancelarEliminar() {
      this.popupVisibleDelete = false;
      this.propietario_id = "";
      this.propietario_nombre = "";
    },
    eliminar() {
      axios.delete('propietarios/' + this.propietario_id).then(response => {
        if (response && response.data.statusCode == 200) {
          this.messageAlert = response.data.message;
          this.cancelarEliminar();
          this.getList();
        }
        else {
          console.log(response);
        }
      }).catch((error) => {
        if (error.response.status == 422) {
          console.log(error);
        } else {
          console.log(this.errors);
        }
      });
    },
    onHiddenDelete(e) {
      this.cancelarEliminar();
    },
    onHiddenStatus(e) {
      this.cancelarStatus;
    },
    getList() {
      axios.get('listar-propietarios').then(response => {
        this.dataSource = response.data.propietarios;
      })
    },
  },
  mounted() {
    this.getList();
  },
}
</script>
<style scoped>
.small {
  font-size: smaller;
}

.error_message {
  color: #FF6868;
  font-weight: normal !important;
}

.active_password {
  font-size: smaller;
  color: #33FFA9;
}

.desactive_password {
  font-size: smaller;
  color: #C4C4C4;
  transition: all 0.3s;
}
</style>
